<template>
    <b-row class="d-flex justify-content-center align-items-center">
      <b-col lg="6" md="6" sm="8" class="mt-5 pt-5">
        <form v-on:submit.prevent="onSubmit">
          <fade-render-transition>
            <card>
              <div slot="header">
                <h3 class="card-title text-center"><strong>Cek Invoice</strong></h3>
              </div>
              <div>
                <fg-input
                          placeholder="Masukkan nomor telp anda"
                          type="text"
                          autofocus
                          name="telp"
                          v-model="model.telp"
                          v-bind:class="errors.has('telp') ? 'is-invalid':''" v-validate="'required'">

                </fg-input>
              </div>
              <div class="text-center">
                <b-button variant="primary" type="submit" class="btn-fill btn-block btn-wd"><font-awesome-icon v-if="isLoading" icon="spinner" spin /> Submit</b-button>
                <!-- <br>
                <div class="forgot">
                  <router-link to="/forgot-password" class="card-category">
                    Forgot your password?
                  </router-link>
                </div> -->
              </div>
            </card>
          </fade-render-transition>
        </form>
      </b-col>
    </b-row>
</template>
<script>
  import { FadeRenderTransition } from '@/components/index'
  export default {
    components: {
      FadeRenderTransition
    },
    data () {
      return {
        errorMsg: null,
        isLoading: false,
        model: {
          telp: ''
        }
      }
    },
    methods: {
      onSubmit () {
        // if (this.isLoading) {
        //   return false
        // }
        this.$validator.validateAll().then(res => {
          this.$notifications.clear()
          if (res) {
            this.isLoading = true
            localStorage.setItem('telp', this.model.telp)
            window.location.href = '#/cek-invoice'
          }
        })
      }
    }
  }
</script>

<style scoped>
  button svg {
    float: left;
    margin-top: 3px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Auth/Login.vue